export default __webpack_public_path__ + "static/media/rain.70b39605.svg";